export const XP = window.XPower
export const XUtils = XP.Utils
export const XTemplate = XP.Template

export const WZ = window.IWangZhe
export const WZUtils = WZ.Utils
